module.exports = __webpack_public_path__ + "static/media/Architecture_27.fdd23922.jpg";